<template>
  <div class="payCardMain" :class="{ google_pay: paystyle == 'google_pay' && !textis }">
    <div class="primer_main">
      <div
        :class="paystyle"
        v-if="orderid != ''"
        :id="'primerother_' + orderid + '_' + paystyle"
      ></div>
    </div>
    <p class="primerother_tip regular" v-show="textis">
      <AutoFitMutilComp
        text-align="center"
        multi-line
        height="100%"
        :max-font-size="0.32"
        :text="$t('pay.error1')"
      ></AutoFitMutilComp>
    </p>
    <div class="cardloadbtn" v-if="payis" @click.stop>
      <img class="btnload" src="@img/icon_loading.png" />
    </div>
  </div>
</template>

<script>
import { getorder } from '@/api/index.js'
import { mapState } from 'vuex'
import { getCallPaymentLimitTrackingProps } from '@/tool/packagePurchaseLimit'
import { primer_payment_fail } from '@/api/index.js'
import { PRIMER_ORDER_STATUS } from '@/enum'
import mixinCheckTaxExpires from '@/mixins/mixinCheckTaxExpires.js'
export default {
  name: 'primerother',
  props: ['payinfo', 'pay_btn_style', 'pay_style'],
  inject: ['newCheckPay'],
  mixins: [mixinCheckTaxExpires],
  computed: {
    ...mapState({
      gameId: (state) => state.app.gameId,
      userInfo: (state) => state.user.userInfo,
      loginType: (state) => state.user.loginType,
      isProductionTax: (state) => state.app.isProductionTax,
    }),
  },
  data() {
    return {
      cardloadis: false,
      payis: false,
      showis: true,
      textis: false,
      //判断是否加载过
      payinitis: false,
      orderid: '',
      //
      paystyle: '',
      paytype: '',
    }
  },
  created() {
    this.paystyle = this.pay_style
    this.cardpay()
  },
  watch: {
    pay_btn_style() {
      this.cardpay()
    },
  },
  mounted() {},
  methods: {
    formatTimestamp(timestamp) {
      const date = new Date(timestamp)
      const Y = date.getFullYear()
      const M = String(date.getMonth() + 1).padStart(2, '0') // 月份从 0 开始
      const D = String(date.getDate()).padStart(2, '0')
      const h = String(date.getHours()).padStart(2, '0')
      const m = String(date.getMinutes()).padStart(2, '0')
      const s = String(date.getSeconds()).padStart(2, '0')
      return `${Y}-${M}-${D} ${h}:${m}:${s}`
    },
    formatUTCTimestamp(timestamp) {
      const date = new Date(timestamp)
      const Y = date.getUTCFullYear()
      const M = String(date.getUTCMonth() + 1).padStart(2, '0') // 月份从 0 开始
      const D = String(date.getUTCDate()).padStart(2, '0')
      const h = String(date.getUTCHours()).padStart(2, '0')
      const m = String(date.getUTCMinutes()).padStart(2, '0')
      const s = String(date.getUTCSeconds()).padStart(2, '0')
      return `${Y}-${M}-${D} ${h}:${m}:${s}`
    },
    async cardpay() {
      if (this.pay_btn_style !== this.paystyle) return
      if (this.payinitis) return

      if (!this.mixinCheckTaxExpires()) {
        return false
      }

      if (this.payinfo.gateway == 8302) {
        this.paytype = 'GOOGLE_PAY'
      } else {
        this.paytype = 'APPLE_PAY'
      }

      this.payinitis = true

      var vm = this
      //load加载之前不让切换
      vm.$parent.apple_google_changeis = false
      //console.log(this.payinfo);
      const params = {
        ...this.payinfo,
        user_id: this.userInfo.user_id,
        enter_type: this.loginType,
        bonus: this.$store.state.user.isFirst ? 1 : 0,
        taxed: this.isProductionTax,
      }
      var res = await getorder(params)

      var orderid = ''

      //校验黑名单之类的
      if (!this.newCheckPay(res)) {
        return false
      }

      if (res.data.code == 1) {
        var clientSession = res.data.data.primer_data
        orderid = res.data.data.provider_order_id
        //为了防止有两个按钮加载
        this.orderid = orderid
        this.$utils.customSessionStorage.setItem('provider_order_id', orderid)
        vm.$parent.updateProviderOrderId(res.data.data.provider_order_id)
        vm.$parent.payment_log.set_properties({
          cg_request_id: res.data.data.provider_order_id + '',
        })
      } else {
        this.$parent.failpay('Order failed！')
        this.$parent.payment_log.report('web_payment_getorder_fail', {
          code: 3,
          msg: res.data.msg ? res.data.msg : 'Order failed',
        })
        this.$rum.report(
          'pay_err',
          {
            paystyle: 'primer_' + (vm.payinfo.gateway == 8302 ? 'google_pay' : 'apple_pay'),
            type: 'getorder',
            response: res.data,
            prams: this.payinfo,
          },
          3
        )
        return
      }

      const { clientToken } = clientSession
      const { Primer } = window
      // Create an instance of the headless checkout

      this.headless = await Primer.createHeadless(clientToken, {
        //locale:'es',
        applePay: {
          buttonStyle: 'black',
        },
        onAvailablePaymentMethodsLoad: this.onAvailablePaymentMethodsLoad,
        onPaymentCreationStart: () => {
          console.log('onPaymentCreationStart')
          this.payis = true
          this.$parent.pay_submitis = true
        },
        onCheckoutComplete: ({ payment }) => this.onCheckoutComplete(payment, params),
        onCheckoutFail: (error, { payment }, handler) =>
          this.onCheckoutFail(error, { payment }, handler, params),
      })
      // Start the headless checkout
      await this.headless.start()
    },
    async onAvailablePaymentMethodsLoad(paymentMethods) {
      // Called when the available payment methods are retrieved
      console.log('paymentMethods======', paymentMethods)
      //console.log(paymentMethods);
      //vm.cardloadis = true
      console.log('type======', this.paytype)
      const hasType = paymentMethods.some((method) => method.type === this.paytype)
      if (hasType) {
        console.log('hasType======', hasType)
        const paymentMethodManager = await this.headless.createPaymentMethodManager(this.paytype)
        const button = paymentMethodManager.createButton()
        console.log(
          this.paystyle + '======button======',
          'primerother_' + this.orderid + '_' + this.paystyle
        )
        button.render('primerother_' + this.orderid + '_' + this.paystyle, {
          style: {
            buttonColor: 'red',
          },
        })

        button.addEventListener('click', () => {
          //this.payis = true;

          const taData = {
            iap_product_id: this.payinfo.product_id,
            payment_type: this.payinfo.gateway == 8302 ? 'google_pay' : 'apple_pay',
            operator_type: 2,
            amount:
              this.isProductionTax && this.payinfo.taxed_price
                ? this.payinfo.taxed_price
                : this.payinfo.amount,
            currency: this.payinfo.currency,
            server_id: this.payinfo.user_extra_value,
            tid: this.orderid,
            use_type: '',
            ...getCallPaymentLimitTrackingProps(this.$parent.pack),
            ...(this.$store.state.app.fromInstalledWebApp
              ? { open_ui_old: 'desktop_shortcut' }
              : {}),
          }
          if (this.gameId === '20195') {
            taData.iap_name = this.payinfo.data_name || ''
            taData.pkg_id = this.payinfo.pack_id || ''
            taData.reward = this.payinfo.reward || ''
          }
          this.$ta.track('call_payment', taData)
        })
        //加载完成可以让切换支付方式
        this.$parent.apple_google_changeis = true
      } else {
        this.showis = false
      }

      if (this.showis == false) {
        this.textis = true
        this.$emit('setPayNo', true)
      } else {
        this.$emit('setPayNo', false)
      }
    },
    onCheckoutComplete(payment, params) {
      // Notifies you that a payment was created
      // Move on to next step in your checkout flow:
      // e.g. Show a success message, giving access to the service, fulfilling the order, ...
      console.log('onCheckoutComplete', payment)

      setTimeout(async () => {
        let isShipBlocked = false
        try {
          const res = await primer_payment_fail({
            uuid: payment.id,
            provider_order_id: this.orderid,
          })
          if (
            res.data.code === 1 &&
            res.data.data.order_status === PRIMER_ORDER_STATUS.SHIP_BLOCKED
          ) {
            isShipBlocked = true
          }
        } catch (error) {
          console.log('onCheckoutComplete error', error)
        }

        if (isShipBlocked) {
          this.$parent.failpay({
            data: {
              uuid: this.orderid,
              now_timestamp: this.$utils.formatUTCTimestamp(Date.now()),
              fail_code: 'pay.limitPackBuyFail',
              tax: this.payinfo.tax,
              taxed_price: this.payinfo.taxed_price,
            },
          })
          this.$rum.report(
            'primer_ship_blocked',
            {
              paystyle: 'primer_' + (this.payinfo.gateway == 8302 ? 'google_pay' : 'apple_pay'),
              type: 'sdkcallback',
              response: payment,
              prams: params,
            },
            1
          )
        } else {
          this.$parent.successpay({
            uuid: payment.id,
            date: this.$utils.formatUTCTimestamp(Date.now()),
          })
          this.$parent.payment_log.report('web_payment_primer_success')

          this.$rum.report(
            'pay_sucess',
            {
              paystyle: 'primer_' + (this.payinfo.gateway == 8302 ? 'google_pay' : 'apple_pay'),
              type: 'sdkcallback',
              response: payment,
              prams: params,
            },
            1
          )
        }

        this.payis = false
        this.$parent.pay_submitis = false
        this.$parent.apple_google_changeis = true
      }, 300)
    },
    onCheckoutFail(error, { payment }, handler, params) {
      payment = payment || {}
      this.$rum.report('primer_fail', { error: error, paymentId: payment.id })
      console.log('onCheckoutFail======', error, handler)
      console.log(error)
      console.log('onCheckouthandler', handler)

      setTimeout(async () => {
        let isShipBlocked = false
        let realAmount = ''
        try {
          const res = await primer_payment_fail({
            uuid: payment.id,
            provider_order_id: this.orderid,
          })
          if (
            res.data.code === 1 &&
            res.data.data.order_status === PRIMER_ORDER_STATUS.SHIP_BLOCKED
          ) {
            isShipBlocked = true
          }
          realAmount = res.data.data.real_amount
        } catch (err) {
          console.log('onCheckoutFail error', err)
        }

        let langKey = ''
        let uuid = payment.id
        if (isShipBlocked) {
          langKey = 'pay.limitPackBuyFail'
          uuid = this.orderid
          this.$rum.report(
            'primer_ship_blocked',
            {
              paystyle: 'primer_' + (this.payinfo.gateway == 8302 ? 'google_pay' : 'apple_pay'),
              type: 'sdkcallback',
              response: payment,
              prams: params,
            },
            1
          )
        }

        this.payis = false
        this.$parent.pay_submitis = false
        this.$parent.apple_google_changeis = true
        this.$parent.failpay({
          data: {
            uuid: uuid,
            now_timestamp: this.$utils.formatUTCTimestamp(Date.now()),
            fail_code: langKey,
            real_amount: realAmount,
            tax: this.payinfo.tax,
            taxed_price: this.payinfo.taxed_price,
          },
        })

        this.$parent.payment_log.report('web_payment_primer_fail', {
          code: 3,
          msg: error ? error : 'fail',
        })

        payment.errormsg = error.message ? error.message : ''

        this.$rum.report(
          'pay_err',
          {
            paystyle: 'primer_' + (this.payinfo.gateway == 8302 ? 'google_pay' : 'apple_pay'),
            type: 'fail',
            response: payment,
            prams: params,
          },
          3
        )
      }, 300)

      // Notifies you that the checkout flow has failed and a payment could not be created
      // This callback can also be used to display an error state within your own UI.
      // ⚠️ `handler` is undefined if the SDK does not expect anything from you
      if (!handler) {
        return
      }
      // ⚠️ If `handler` exists, you MUST call one of the functions of the handler
      // Show a default error message
      return handler.showErrorMessage()
    },
  },
}
</script>

<style lang="less" scoped>
.payCardMain {
  width: 100%;
  height: 100%;
  position: relative;
  border-radius: 20px;
  overflow: hidden;
  &.google_pay {
    &::after {
      box-sizing: border-box;
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      border: 2px solid #000;
      border-radius: 20px;
      pointer-events: none;
    }
    &:hover {
      &::after {
        border-color: #3c4043;
      }
    }
  }
}
.primer_main {
  width: 100%;
  height: 100%;
  .google_pay {
    font-size: 0;
    height: 100%;
    width: 100%;
    // ::v-deep(.gpay-card-info-container-fill) {
    //   display: flex;
    //   align-items: center;
    // }
    ::v-deep(.gpay-button-fill) {
      .gpay-button {
        min-height: auto;
        padding-top: 12px;
        padding-bottom: 10px;
      }
    }
    ::v-deep(.gpay-card-info-animation-container),
    ::v-deep(.gpay-card-info-iframe),
    ::v-deep(.gpay-card-info-container) {
      border-radius: 20px;
      overflow: hidden;
      outline: none;
      border: none;
      height: 40px;
      /* 关键：添加-webkit-mask解决iOS裁剪问题 */
      // -webkit-mask-image: -webkit-radial-gradient(white, black);
    }
  }
  .apple_pay {
    height: 40px;
  }
  ::v-deep(.primer-apple-pay-button) {
    height: 40px !important;
  }
}
.cardloadbtn {
  width: 100%;
  height: 100%;
  position: absolute;
  background-color: rgba(0, 0, 0, 0.5);
  border-radius: 6px;
  top: 0;
  left: 0;
  align-items: center;
  z-index: 1111;
}
.cardloadbtn img {
  display: block;
  margin: 0 auto;
  width: 20px;
  height: 20px;
  margin-top: 10px;
  animation: rotate 1s linear infinite;
}
.primerother_tip {
  font-size: 12px;
  color: rgba(0, 0, 0, 0.5);
  position: absolute;
  width: 100%;
  height: 100%;
  background-color: #fff;
  top: 0;
  left: 0;
  text-align: center;
}
</style>
